export default __webpack_public_path__ + "static/media/retailer_bg.ce3e6a2a.gif";